var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPtStopLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 125,
    viewBox: "0 0 67 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.5V124H7.5V103M1 11.5V0.5H66.5V11.5H7.5M1 11.5H7.5M7.5 11.5V98.5M7.5 98.5H28.5V103H7.5M7.5 98.5V103",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11.5V15.5M20.5 15.5H10.5V34H62.5V15.5H53M20.5 15.5H53M53 15.5V11.5",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 31V19H58.5V31H14.5Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21H43M52.5 21H56.5M17 27H43M52.5 25H56.5M17 23H43M17 25H43M17 29H43M52.5 23H56.5M52.5 27H56.5M52.5 29H56.5",
    stroke: "black",
    strokeWidth: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPtStopLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PTStopLeft.01ab6822b22e1be2c6971ec1d7a2b9d1.svg";